export { default } from './MessageBubbleOutline'
